// import React from "react";

// export const FormInput = ({
//   label,
//   name,
//   value,
//   onChange,
//   type = "text",
//   placeholder = "",
//   required = false,
//   disabled = false,
//   options = [],
//   className = "",
// }) => {
//   const inputClasses = `
//     w-full px-4 py-2.5 rounded-lg
//     border border-gray-300 
//     bg-white 
//     transition-all duration-200
//     focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
//     disabled:bg-gray-50 disabled:text-gray-500
//     placeholder-gray-400
//   `;

//   return (
//     <div className={`w-full mb-6 ${className}`}>
//       <label
//         htmlFor={name}
//         className="block text-sm font-medium text-gray-700 mb-1"
//       >
//         {label}
//         {required && <span className="text-red-500 ml-1">*</span>}
//       </label>
//       {type === "select" ? (
//         <select
//           id={name}
//           name={name}
//           value={value}
//           onChange={onChange}
//           disabled={disabled}
//           className={inputClasses}
//         >
//           <option value="">Select {label}</option>
//           {options.map((option) => (
//             <option key={option.value} value={option.value}>
//               {option.label}
//             </option>
//           ))}
//         </select>
//       ) : (
//         <input
//           type={type}
//           id={name}
//           name={name}
//           value={value}
//           onChange={onChange}
//           disabled={disabled}
//           placeholder={placeholder}
//           className={inputClasses}
//         />
//       )}
//     </div>
//   );
// };
// FormInput.jsx - Unified and Enhanced Version
import React from "react";

export const FormInput = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder = "",
  required = false,
  disabled = false,
  error,
  options = [],
  className = "",
  step, // For number inputs
  accept, // For file inputs
}) => {
  const inputClasses = `
    w-full px-4 py-2.5 rounded-lg
    border ${error ? "border-red-300" : "border-gray-300"}
    bg-white 
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
    disabled:bg-gray-50 disabled:text-gray-500
    placeholder-gray-400
    ${error ? "focus:ring-red-500 focus:border-red-500" : ""}
  `;

  return (
    <div className={`w-full mb-6 ${className}`}>
      {/* Label */}
      <label
        htmlFor={name}
        className="block text-sm font-medium text-gray-700 mb-2"
      >
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      {/* Select Dropdown */}
      {type === "select" ? (
        <select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={inputClasses}
          required={required}
        >
          <option value="">Select {label}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : type === "textarea" ? (
        /* Textarea */
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          required={required}
          className={`${inputClasses} min-h-[100px] resize-vertical`}
          rows={4}
        />
      ) : (
        /* Regular Input */
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          required={required}
          step={step}
          accept={accept}
          className={inputClasses}
        />
      )}

      {/* Error Message */}
      {error && (
        <p className="mt-2 text-sm text-red-600 flex items-center gap-1">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
};

// Also export FormSelect for backward compatibility
export const FormSelect = ({ label, options, error, ...props }) => (
  <FormInput
    label={label}
    type="select"
    options={options}
    error={error}
    {...props}
  />
);